export default [
    // {
    //     path: '/lookDetail',
    //     component: () => import('@/pages/serviceManager/lookDetail'),
    //     meta: {
    //         display: 'none',
    //     },
    // },
];
